<template>
  <div class="event-page">
    <div class="event-header">
      <div class="event-title">事件中心</div>
    </div>
    <div class="event-content">
      <a-tabs v-model:activeKey="tab">
        <a-tab-pane key="list" tab="事件列表">
          <div class="container">
            <div class="filter-area">
              <a-space>
                事件类别:
                <a-select v-model:value="category" @change="onChange" style="width:150px;margin-right: 20px">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option v-for="item in categoryOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>

                来源:
                <a-select v-model:value="source" @change="onChange" style="width:150px;margin-right: 20px">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option v-for="item in sourceOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>

                事件状态:
                <a-select v-model:value="status" @change="onChange" style="width:100px;margin-right: 20px">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option v-for="item in statusOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>

                <a-button type="primary" @click="onReset">重置</a-button>

              </a-space>
            </div>
            <div class="main">
              <a-table :columns="columns" :data-source="dataSource" style="width: 100%" :pagination="pagination"
                @change="handleTableChange" :loading="loading" :scroll="{ x: 1300 }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'status'">
                    <span>
                      <a-tag :color="colorMap[record[column.key]]">
                        {{ getStatusLabel(record[column.key]) }}
                      </a-tag>
                    </span>
                  </template>

                  <template v-else-if="column.key === 'category'">
                    <span>{{ getCategoryLabel(record[column.key]) }}</span>
                  </template>

                  <template v-else-if="column.key === 'source'">
                    <span>{{ getSourceLabel(record[column.key]) }}</span>
                  </template>

                  <template v-else-if="column.key === 'action'">
                    <span>
                      <!-- 根据状态显示不同的操作按钮 -->
                      <template v-if="record.status === STATUS_REVIEWING">
                        <a @click="onDetail(record, 2)">审批</a>
                      </template>
                      <template v-else>
                        <a @click="onDetail(record, 0)">查看</a>
                      </template>
                      
                      <!-- 只有待处理和待审核状态才能修改 -->
                      <template v-if="record.status === STATUS_PENDING || record.status === STATUS_REVIEWING">
                        <a-divider type="vertical" />
                        <a @click="onDetail(record, 1)">修改</a>
                      </template>
                      
                      <!-- 只有待处理和待审核状态才能删除 -->
                      <template v-if="record.status === STATUS_PENDING || record.status === STATUS_REVIEWING">
                        <a-divider type="vertical" />
                        <a @click="onDelete(record)" style="color:red">删除</a>
                      </template>
                    </span>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="chart" tab="事件图表">
          <div class="container">
            <event-charts />
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    
    <!-- 添加EventDetail组件，并添加ref引用，监听刷新事件 -->
    <event-detail ref="eventDetail" @refresh="loadData" />
  </div>
</template>

<script>
import randomData from "./data.js";
import { Modal } from "ant-design-vue";
import EventDetail from "@/page/event/EventDetail";
import EventCharts from "@/page/event/components/EventCharts";
import api from "@/request/api";
import { 
  EVENT_SOURCE_OPTIONS, 
  EVENT_CATEGORY_OPTIONS, 
  EVENT_STATUS_OPTIONS,
  EVENT_STATUS_LABEL,
  EVENT_STATUS_COLOR,
  EVENT_SOURCE_LABEL,
  EVENT_CATEGORY_LABEL,
  EVENT_STATUS
} from "@/constants/eventEnums";

export default {
  name: "Event",
  components: { EventCharts, EventDetail },
  data() {
    return {
      tab: "list",
      //tab: "chart",
      baseData: randomData,
      status: "",
      handler: "",
      source: "",
      category: "",
      colorMap: EVENT_STATUS_COLOR,
      sourceOptions: EVENT_SOURCE_OPTIONS,
      categoryOptions: EVENT_CATEGORY_OPTIONS,
      statusOptions: EVENT_STATUS_OPTIONS,
      EVENT_STATUS_COLOR,
      EVENT_STATUS_LABEL,
      EVENT_SOURCE_LABEL,
      EVENT_CATEGORY_LABEL,
      // 定义状态常量
      STATUS_PENDING: 10,
      STATUS_REVIEWING: 20,
      STATUS_COMPLETED: 91,
      STATUS_REJECTED: 92,
      STATUS_CANCELED: 93,
      columns: [{
        title: '编号',
        dataIndex: 'event_id',
        key: 'event_id',
        width: 180,
      }, {
        title: '事件类别',
        dataIndex: 'category',
        key: 'category',
        width: 120,
        customRender: ({ text }) => {
          return EVENT_CATEGORY_LABEL[text] || text;
        }
      }, {
        title: '来源',
        dataIndex: 'source',
        key: 'source',
        width: 120,
        customRender: ({ text }) => {
          return EVENT_SOURCE_LABEL[text] || text;
        }
      }, {
        title: "位置",
        key: 'location',
        dataIndex: 'location',
        width: 150,
      }, {
        title: "处理人",
        key: "handler",
        dataIndex: "handler",
        width: 100,
      },
        {
          title: "状态",
          key: 'status',
          dataIndex: 'status',
          width: 100,
          customRender: ({ text }) => {
            // 如果状态是数字，转换为对应的文本显示
            const statusText = typeof text === 'number' ? EVENT_STATUS_LABEL[text] : text;
            return {
              children: statusText,
              props: {
                style: {
                  color: EVENT_STATUS_COLOR[text] || 'default'
                }
              }
            };
          }
        }, {
          title: "创建时间",
          key: 'created_at',
          dataIndex: 'created_at',
          width: 150,
          customRender: ({ text }) => {
            // 将时间戳转换为可读时间
            return text ? new Date(text).toLocaleString() : '';
          }
        }, {
          title: "处理时间",
          key: 'process_at',
          dataIndex: 'process_at',
          width: 150,
          customRender: ({ text }) => {
            // 将时间戳转换为可读时间，如果为0则显示空
            return text && text !== 0 ? new Date(text).toLocaleString() : '';
          }
        }, {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 180,
        }],
      dataSource: [],
      // 分页相关
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
        showTotal: (total) => `共 ${total} 条`
      },
      loading: false
    }
  },
  mounted() {
    this.checkQueryParams();
    this.loadData();
    this.addEmit();
  },
  methods: {
    // 检查URL查询参数，设置筛选条件
    checkQueryParams() {
      // 从URL查询参数中获取筛选条件
      const { status, handler, source, category } = this.$route.query;
      
      // 如果有查询参数，设置对应的筛选条件
      if (status) this.status = Number(status); // 转换为字符串，确保与选择器值类型一致
      
      if (handler) this.handler = handler;
      if (source) this.source = source;
      if (category) this.category = category;
      
      // 如果有筛选条件，自动切换到列表标签页
      if (status || handler || source || category) {
        this.tab = "list";
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const params = {
          condition: {
            category: this.category || null,
            source: this.source || null,
            status: this.status || null,
          },
          paging: {
            page: this.pagination.current,
            page_size: this.pagination.pageSize,
            sort_field: "created_at",
            sort_asc: false,
            total_num: true
          }
        };

        const res = await api.events.list(params);
        
        if (res) {
          // 假设API返回格式为 { data: { list: [...], total: 100 } }
          this.dataSource = res.list || [];
          this.pagination.total = res.total || 0;
          
          // 如果需要对数据进行转换，可以在这里处理
          // 例如，将类别和来源的代码转换为对应的文本显示
          if (this.dataSource.length > 0) {
            this.dataSource = this.dataSource.map(item => {
              // 直接使用API返回的字段，不需要映射
              return {
                ...item,
                // 可以在这里添加额外的处理逻辑
              };
            });
          }
        }
      } catch (error) {
        console.error('获取事件列表失败:', error);
        this.$message.error('获取事件列表失败');
      } finally {
        this.loading = false;
      }
    },
    onDetail(record, type) {
      // type: 0-查看, 1-修改, 2-审批
      // 将记录传递给详情组件
      this.$refs.eventDetail && this.$refs.eventDetail.open && this.$refs.eventDetail.open(record, type);
    },
    onDelete(record) {
      Modal.confirm({
        title: '警告',
        content: `是否删除编号为 ${record.event_id} 的事件数据？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          // try {
          //   // 这里可以添加删除API调用
          //   await api.events.update(record.event_id,93);
            // this.$message.success('删除成功');
            // this.loadData(); // 重新加载数据
          // } catch (error) {
          //   console.error('删除失败:', error);
          //   this.$message.error('删除失败');
          // }
        }
      });
    },
    onReset() {
      this.handler = "";
      this.status = "";
      this.category = "";
      this.source = "";
      this.pagination.current = 1;
      this.loadData();
    },
    onChange() {
      this.pagination.current = 1;
      this.loadData();
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },
    getStatusLabel(status) {
      return EVENT_STATUS_LABEL[status] || status;
    },
    getCategoryLabel(category) {
      return EVENT_CATEGORY_LABEL[category] || category;
    },
    getSourceLabel(source) {
      return EVENT_SOURCE_LABEL[source] || source;
    },
    addEmit() {
      this.$emitter.on('open-event', (data) => {
        if (data) {
          this.handler = data.handler || "";
          this.status = data.status || "";
          this.source = data.source || "";
          this.category = data.category || "";
          this.onChange();
        }
      });
    }
  },
  watch: {
    // 监听路由变化，更新筛选条件
    '$route.query': {
      handler() {
        this.checkQueryParams();
        this.loadData();
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.event-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
}

.event-header {
  height: 64px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 0 24px;
  display: flex;
  align-items: center;

  .event-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1890ff;
  }
}

.event-content {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  :deep(.ant-tabs) {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }

  :deep(.ant-tabs-content) {
    flex: 1;
    height: 100%;
  }

  :deep(.ant-tabs-tabpane) {
    height: 100%;
    overflow: auto; /* 在这里添加滚动条 */
  }

  :deep(.ant-tabs-nav) {
    margin-bottom: 16px;
    background: white;
    padding: 0 16px;
  }
}

.container {
  width: 100%;
  background: white;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  height: auto;
  min-height: 0; /* 移除最小高度限制 */
}

.main {
  width: 100%;
}

.filter-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 20px 20px;
}
</style>